<div class="flex flex-col flex-auto max-h-210 -m-6 overflow-y-auto" style="min-width: 60vw; max-width: 82vw;">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">Quote Details</div>
        <button
            mat-icon-button
            (click)="matDialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Card form -->
    <form
        *ngIf="cardForm"
        class="flex flex-col flex-0 items-start w-full space-t-6"
        [formGroup]="cardForm">

        <div class="details-content flex flex-col flex-0 items-start w-full p-6 sm:p-8 space-y-6 overflow-y-auto" style="max-height: 72vh;">

            <div class="grid grid-cols-12 gap-4 w-full">

                <div class="col-span-12 flex justify-between -mt-2 mb-2">
                    <!-- Set Reminder -->
                    <button
                        *ngIf="!isProspectsStage(deal?.stageId) && !isFollowUpStage(deal?.stageId)"
                        (click)="setReminder()"
                        mat-flat-button
                        color="primary"
                        [disabled]="!deal?.dealId">
                        <mat-icon [svgIcon]="hasReminder ? 'mat_outline:edit_notifications' : 'mat_outline:notification_add'"></mat-icon>
                        <span class="ml-1">{{hasReminder ? 'Edit' : 'Set'}} Reminder</span>
                    </button>

                    <!-- Upload Quote -->
                    <button
                        *ngIf="!isProspectsStage(deal?.stageId) && !isFollowUpStage(deal?.stageId)"
                        (click)="openQuoteUpload()"
                        mat-flat-button
                        color="primary"
                        [disabled]="!deal?.dealId">
                        <mat-icon [svgIcon]="'mat_outline:file_upload'"></mat-icon>
                        <span class="ml-1">Upload Quote</span>
                    </button>
                </div>

                <!-- Title -->
                <mat-form-field class="w-full col-span-3" [subscriptSizing]="'dynamic'">
                    <mat-label>Name</mat-label>
                    <textarea
                        matInput
                        [formControlName]="'name'"
                        [rows]="1"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="1">
                    </textarea>
                </mat-form-field>
                
                <!-- Quote Ref (readonly) -->
                <mat-form-field class="w-full col-span-2" [subscriptSizing]="'dynamic'">
                    <mat-label>Quote Ref</mat-label>
                    <input
                        matInput
                        readonly
                        [disabled]="!dealId"
                        [value]="deal?.quoteNumber || deal?.quoteRef || ''">
                </mat-form-field>

                <!-- Quote Created date (readonly) -->
                <mat-form-field class="w-full col-span-2" [subscriptSizing]="'dynamic'">
                    <mat-label>Quote Created</mat-label>
                    <input
                        matInput
                        readonly
                        [disabled]="!dealId"
                        [value]="getQuoteCreated()">
                </mat-form-field>
                
                <!-- Customer Req No -->
                <mat-form-field class="w-full col-span-2" [subscriptSizing]="'dynamic'">
                    <mat-label>Customer Req No.</mat-label>
                    <input
                        matInput
                        [formControlName]="'customerReqNo'">
                </mat-form-field>

                <!-- Value + Reminder -->
                <div class="w-full flex space-between col-span-3">
                    <mat-form-field
                        [style]="isNegotiationStage(deal?.stageId) || isProposalStage(deal?.stageId) ? 'width: calc(100% - 40px)' : 'width: 100%'"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Value</mat-label>
                        <span matPrefix style="color: black;">£</span>
                        <input
                            matInput
                            [formControlName]="'value'"
                            (blur)="updateValidators()">
                    </mat-form-field>
                    <div *ngIf="isNegotiationStage(deal?.stageId) || isProposalStage(deal?.stageId)" class="flex flex-col gap-2 justify-end items-center pl-4">
                        <mat-icon
                            class="icon-size-6"
                            [svgIcon]="'mat_outline:timer'"></mat-icon>
                        <span class="text-orange-500 whitespace-nowrap">{{getTimeSinceLastEmail()}}</span>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-5 gap-4 w-full">
                <!-- Stage -->
                <div>
                    <div class="font-medium">Stage *</div>
                    <div class="custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                        <mat-form-field
                            class="w-full custom-mat-select"
                            [subscriptSizing]="'dynamic'">
                            <mat-select
                                class="user-select"
                                [formControlName]="'stageId'"
                                [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-72'"
                                disableOptionCentering
                                #stageSelect="matSelect">
                                <ng-container *ngFor="let stage of stages">
                                    <mat-option
                                        class="h-auto py-4 leading-none"
                                        [value]="stage?.stageId">
                                        <div class="font-medium">{{ stage?.name }}</div>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Category -->
                 <div>
                    <div class="font-medium">Label {{validatorsOn ? '*' : ''}}</div>
                    <div class="custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                        <mat-form-field
                            class="w-full custom-mat-select"
                            [subscriptSizing]="'dynamic'">
                            <mat-icon
                                class="user-icon icon-size-5 text-current mr-2"
                                [svgIcon]="'heroicons_outline:tag'">
                            </mat-icon>
                            <mat-select
                                class="user-select"
                                multiple
                                [formControlName]="'dealCategories'"
                                [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-72'"
                                disableOptionCentering
                                #categorySelect="matSelect"
                                (selectionChange)="cardForm.markAsDirty()">
                                <!-- <mat-option class="h-auto py-4 leading-none"
                                    [value]="null">
                                    <div class="font-medium">None</div>
                                </mat-option> -->
                                <ng-container *ngFor="let category of categories">
                                    <mat-option
                                        class="h-auto py-4 leading-none"
                                        [value]="category.value">
                                        <div class="font-medium">{{ category.name }}</div>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Sent Date -->
                <div>
                    <div class="font-medium">Sent Date {{validatorsOn ? '*' : ''}}</div>
                    <div
                        class="relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700"                    
                        (click)="sentDatePicker.open()">
                        <mat-icon
                            class="icon-size-5 text-current mr-2"
                            [svgIcon]="'heroicons_solid:calendar'"></mat-icon>
                        <span class="text-md font-medium">
                            <ng-container *ngIf="cardForm?.get('sentDate').value">{{cardForm?.get('sentDate').value | date:'longDate'}}</ng-container>
                            <ng-container *ngIf="!cardForm?.get('sentDate').value">Not set</ng-container>
                        </span>
                        <mat-form-field
                            class="fuse-mat-dense invisible absolute inset-0 -mt-2.5 opacity-0 pointer-events-none"
                            [subscriptSizing]="'dynamic'">
                            <input
                                matInput
                                [formControlName]="'sentDate'"
                                [matDatepicker]="sentDatePicker">
                            <mat-datepicker #sentDatePicker>
                                <mat-datepicker-actions>
                                    <button
                                        mat-button
                                        (click)="cardForm?.get('sentDate').setValue(null)"
                                        matDatepickerCancel>
                                        Clear
                                    </button>
                                    <button
                                        mat-flat-button
                                        [color]="'primary'"
                                        matDatepickerApply>
                                        Select
                                    </button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Close Date -->
                <div>
                    <div class="font-medium">Close Date</div>
                    <div
                        class="relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700"                    
                        (click)="closeDatePicker.open()">
                        <mat-icon
                            class="icon-size-5 text-current mr-2"
                            [svgIcon]="'heroicons_solid:calendar'"></mat-icon>
                        <span class="text-md font-medium">
                            <ng-container *ngIf="cardForm?.get('closeDate').value">{{cardForm?.get('closeDate').value | date:'longDate'}}</ng-container>
                            <ng-container *ngIf="!cardForm?.get('closeDate').value">Not set</ng-container>
                        </span>
                        <mat-form-field
                            class="fuse-mat-dense invisible absolute inset-0 -mt-2.5 opacity-0 pointer-events-none"
                            [subscriptSizing]="'dynamic'">
                            <input
                                matInput
                                [formControlName]="'closeDate'"
                                [matDatepicker]="closeDatePicker">
                            <mat-datepicker #closeDatePicker>
                                <mat-datepicker-actions>
                                    <button
                                        mat-button
                                        (click)="cardForm?.get('closeDate').setValue(null)"
                                        matDatepickerCancel>
                                        Clear
                                    </button>
                                    <button
                                        mat-flat-button
                                        [color]="'primary'"
                                        matDatepickerApply>
                                        Select
                                    </button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <!-- User -->
                <div>
                    <div class="font-medium">User *</div>
                    <div class="custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                        <mat-form-field
                            class="w-full custom-mat-select"
                            [subscriptSizing]="'dynamic'">
                            <mat-icon
                                class="user-icon icon-size-5 text-current mr-2"
                                [svgIcon]="'heroicons_outline:user'">
                            </mat-icon>
                            <mat-select
                                class="user-select"
                                [formControlName]="'userId'"
                                [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-72'"
                                disableOptionCentering
                                #userSelect="matSelect">
                                <ng-container *ngFor="let user of users">
                                    <mat-option
                                        class="h-auto py-4 leading-none"
                                        [value]="user.id">
                                        <div class="font-medium">{{ user.firstName }} {{ user.lastName }}</div>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- non-lead quote -->
                <ng-container *ngIf="!deal.isLeadQuote">
                    <!-- Company -->
                    <div>
                        <div class="font-medium">Company {{validatorsOn ? '*' : ''}}</div>
                        <div class="custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <mat-form-field
                                class="w-full custom-mat-select fuse-mat-dense"
                                [subscriptSizing]="'dynamic'">
                                <input
                                    class="user-select"
                                    matInput
                                    [matAutocomplete]="auto"
                                    [value]="selectedCompanyName"
                                    (input)="filterCompanies($event)">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <ng-container *ngFor="let company of filteredCompanies">
                                        <mat-option [value]="company.name" (onSelectionChange)="onCompanySelected(company)">
                                            {{ company.name }}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Contact -->
                    <div>
                        <div class="font-medium">Contact {{validatorsOn ? '*' : ''}}</div>
                        <div class="custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <mat-form-field
                                class="w-full custom-mat-select"
                                [subscriptSizing]="'dynamic'">
                                <mat-icon
                                    class="user-icon icon-size-5 text-current mr-2"
                                    [svgIcon]="'heroicons_outline:user'">
                                </mat-icon>
                                <mat-select
                                    class="user-select"
                                    [formControlName]="'contactId'"
                                    [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #contactSelect="matSelect">
                                    <ng-container *ngFor="let contact of getCompanyContacts(); trackBy: trackByFn">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="contact?.id">
                                            <div class="font-medium">{{ contact?.name }}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Email</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            
                            <div class="custom-mat-select text-left">
                                {{getContactEmail()}}
                            </div>
                            
                            <!-- <mat-form-field
                                class="w-full custom-mat-select"
                                [subscriptSizing]="'dynamic'"> -->
                                <!-- <mat-icon
                                    class="user-icon icon-size-5 text-current mr-2"
                                    [svgIcon]="'heroicons_outline:user'">
                                </mat-icon> -->
                                <!-- <mat-select
                                    class="user-select"
                                    [formControlName]="'contactEmailId'"
                                    [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-72'"
                                    disableOptionCentering
                                    #contactSelect="matSelect">
                                    <ng-container *ngFor="let email of getContactEmails()">
                                        <mat-option
                                            class="h-auto py-4 leading-none"
                                            [value]="email.contactEmailId">
                                            <div class="font-medium">{{ email.email }}</div>
                                        </mat-option>
                                    </ng-container>
                                </mat-select> -->
                            <!-- </mat-form-field> -->
                        </div>
                    </div>

                    <!-- Phone number -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Phone Number</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            
                            <div class="custom-mat-select text-left">
                                {{getContactPhoneNumber()}}
                            </div>
                        </div>
                    </div>

                    <!-- Department -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Department</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            
                            <div class="custom-mat-select text-left">
                                {{getContactDepartment()}}
                            </div>
                        </div>
                    </div>
                </ng-container>
                
                <!-- lead quote -->
                <ng-container *ngIf="deal.isLeadQuote">
                    <!-- Company -->
                    <div>
                        <div class="font-medium">Company</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <div class="custom-mat-select text-left truncate elipsis">
                                {{lead?.leadCompany}}
                            </div>
                        </div>
                    </div>

                    <!-- Contact -->
                    <div>
                        <div class="font-medium">Lead</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <div class="custom-mat-select text-left">
                                {{lead?.name}}
                            </div>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Email</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <div class="custom-mat-select text-left">
                                {{getLeadEmail()}}
                            </div>
                        </div>
                    </div>

                    <!-- Phone number -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Phone Number</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <div class="custom-mat-select text-left">
                                {{getLeadPhoneNumber()}}
                            </div>
                        </div>
                    </div>

                    <!-- Department -->
                    <div class="overflow-hidden" style="min-width: 100%; max-width: min-content;">
                        <div class="font-medium">Department</div>
                        <div class="h-[35px] custom-mat-form-field w-full elipsis text-center mx-auto relative flex items-center mt-1.5 px-4 leading-9 rounded-full text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                            <div class="custom-mat-select text-left">
                                {{lead?.department}}
                            </div>
                        </div>
                    </div>
                </ng-container>


            </div>

            <!-- Notes -->
            <div class="w-full border-t"></div>
            <mat-label>Notes</mat-label>
            <mat-form-field
                class="w-full"
                [subscriptSizing]="'dynamic'">
                <textarea
                    matInput
                    [formControlName]="'notes'"
                    [rows]="3"
                    cdkTextareaAutosize
                    [cdkAutosizeMinRows]="2">
                </textarea>
            </mat-form-field>

            <!-- Parts Description -->
            <div class="w-full border-t"></div>
            <mat-label class="flex justify-between w-full cursor-pointer" (click)="partsExpanded = !partsExpanded;">
                Parts
                <mat-icon *ngIf="partsExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!partsExpanded">chevron_right</mat-icon>
            </mat-label>
            <mat-form-field
                class="w-full"
                [class.hidden]="!partsExpanded"
                [subscriptSizing]="'dynamic'">
                <textarea
                    matInput
                    [formControlName]="'partsDescription'"
                    [rows]="2"
                    cdkTextareaAutosize
                    [cdkAutosizeMinRows]="2">
                </textarea>
            </mat-form-field>

            <!-- Attachments -->
            <div class="w-full border-t"></div>
            <mat-label class="flex justify-between w-full cursor-pointer" (click)="filesExpanded = !filesExpanded;">
                Attachments
                <mat-icon *ngIf="filesExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!filesExpanded">chevron_right</mat-icon>
            </mat-label>
            <div [class.hidden]="!filesExpanded" class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden" style="height:102px;">                
                <div> <!--class="-ml-2"-->
                    <!-- Upload file -->
                    <button mat-icon-button
                    (click)="openFileUpload()">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                    </button>
                </div>

                <!-- Files -->
                <ng-container *ngIf="files?.length > 0">
                    <div class="file-container p-2 mx-1" *ngFor="let file of files">
                        <!-- Icons -->
                        <div class="relative cursor-pointer text-center" (click)="download(file)">
                            <div class="inline-block relative text-center">
                                <mat-icon
                                    class="icon-size-14 text-hint opacity-50"
                                    [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                <div
                                    class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                    [class.bg-red-600]="file.type == '.pdf'"
                                    [class.bg-blue-600]="file.type == '.doc'"
                                    [class.bg-green-600]="file.type == '.xls'"
                                    [class.bg-gray-600]="file.type == '.txt'"
                                    [class.bg-amber-600]="file.type == '.jpg'"
                                    [class.bg-yellow-500]="file.type == '.png'">
                                    {{file.type.toUpperCase()}}
                                </div>
                                <button *ngIf="!isBasic" class="absolute" (click)="deleteFile(file, $event)">
                                    <mat-icon class="icon-size-2 text-red-600">close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="file-name cursor-pointer text-s text-center mt-1" (click)="download(file)">{{file.name}}</div>
                    </div>
                </ng-container>
            </div>

            <!-- Email Trail -->
            <ng-container *ngIf="dealId && deal.emailTrails?.length">
                <div class="w-full border-t"></div>
                <mat-label class="flex justify-between w-full cursor-pointer" (click)="emailExpanded = !emailExpanded;">
                    Email Trail
                    <mat-icon *ngIf="emailExpanded">expand_more</mat-icon>
                    <mat-icon *ngIf="!emailExpanded">chevron_right</mat-icon>
                </mat-label>
                
                <div class="flex flex-col gap-4 divide-y w-full" [class.hidden]="!emailExpanded">
                    <ng-container *ngFor="let email of deal.emailTrails; let first = first;">
                        <div class="flex flex-row gap-4 w-full" [class.pt-4]="!first">
                            <div class="flex flex-col gap-2">
                                <span>Subject:</span>
                                <span>Date:</span>
                                <span>From:</span>
                                <span>Body:</span>
                            </div>

                            <div class="flex flex-col gap-2 min-w-0 flex-1">
                                <span>{{email.subject}}</span>
                                <span>{{email.date | date:'d MMM yyyy HH:mm'}}</span>
                                <div class="flex flex-row gap-4">
                                    <span>{{email.fromName}}</span>
                                    <span class="italic">{{email.fromEmail}}</span>
                                </div>
                                <div class="whitespace-wrap" [innerHTML]="email.body"></div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Lost Reason -->
            <ng-container *ngIf="dealId && isDealLost()">
                <div class="w-full border-t"></div>
                <mat-label class="flex justify-between w-full cursor-pointer" (click)="lostReasonExpanded = !lostReasonExpanded;">
                    Lost Reason
                    <mat-icon *ngIf="lostReasonExpanded">expand_more</mat-icon>
                    <mat-icon *ngIf="!lostReasonExpanded">chevron_right</mat-icon>
                </mat-label>
                <div [class.hidden]="!lostReasonExpanded" class="w-full">
                    <app-comments
                        *ngIf="lostReasonComments?.length > 0"
                        class="w-full"
                        titleClass="hidden"
                        style="margin-top: 0 !important;"
                        [comments]="lostReasonComments"
                        [parentId]="deal?.dealId"
                        [readOnly]="true">
                    </app-comments>
                    <div *ngIf="!lostReasonComments?.length" class="w-full p-4 text-center text-gray-500 italic">
                        No loss reason recorded yet.
                    </div>
                </div>
            </ng-container>

            <!-- Comments -->
            <ng-container *ngIf="dealId">
                <div class="w-full border-t"></div>
                <mat-label class="flex justify-between w-full cursor-pointer" (click)="commentsExpanded = !commentsExpanded;">
                    Comments
                    <mat-icon *ngIf="commentsExpanded">expand_more</mat-icon>
                    <mat-icon *ngIf="!commentsExpanded">chevron_right</mat-icon>
                </mat-label>
                <app-comments
                    [class.hidden]="!commentsExpanded"
                    class="w-full"
                    titleClass="hidden"
                    style="margin-top: 0 !important;"
                    [comments]="genericComments"
                    [parentId]="deal?.dealId"
                    ($commentAdded)="addComment($event)"
                    ($commentChanged)="updateComment($event)"
                    ($commentDeleted)="removeComment($event)">
                </app-comments>
            </ng-container>

        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end w-full border-t p-6 sm:p-8">
            <!-- Delete -->
            <button
                class="mr-auto"
                (click)="archiveCard()"
                mat-stroked-button
                color="warn"
                [disabled]="!deal?.dealId"
                type="button">
                Delete
            </button>

            <!-- Cancel -->
            <button
                class="ml-auto"
                mat-button
                [matTooltip]="'Cancel'"
                (click)="close(false)">
                Cancel
            </button>
            <!-- Save -->
            <button
                class="ml-2"
                mat-flat-button
                [color]="'primary'"
                [disabled]="false"
                [matTooltip]="'Save'"
                (click)="save()"
                [disabled]="cardForm.invalid || cardForm.pristine">
                Save
            </button>
        </div>
    </form>
</div>
